import { GetStoryActivityLogsMeta, GetStoryActivityLogsPayload } from 'types/store/GetStoryActivityLogs';
import { createAsyncReducer } from 'utils/Redux';

import { getStoryActivityLogsActions } from '../actions';

export default createAsyncReducer<GetStoryActivityLogsMeta, GetStoryActivityLogsPayload>(getStoryActivityLogsActions);
